import axios from "axios";

const CarryScore = (state = [], action) => {
    switch (action.type) {
        case 'GET_CARRY_SCORE':
            return state;
        case 'SET_CARRY_SCORE'  :
            state = action.payload;
            return state;
        case 'UPDATE_CARRY_SCORE_INPUT'  :
            state = action.payload;
            return state;
        default:
            return state;
    }
};
export default CarryScore;
